export const FETCH_CURRENT_USER_REQUEST = "FETCH_CURRENT_USER_REQUEST";
export const FETCH_CURRENT_USER_SUCCESS = "FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "FETCH_CURRENT_USER_FAILURE";

export const SIGNOUT_REQUEST = "SIGNOUT_REQUEST";
export const CLEAR_ACCOUNT_REQUEST = "CLEAR_ACCOUNT_REQUEST";